<template>
  <div class="auth">
    <div class="banner"></div>
    <div class="help"></div>
    <div class="main">
      <div class="logo"></div>
      <div class="title">2-Step Verification</div>

      <v-card flat="flat" class="card" :loading="loading">
        <v-card-text>
          <v-form v-model="valid" ref="form" lazy-validation>
            <div class="screen-2fa">
              <span>A text message with your code has been sent to:</span>
              <p>
                ****** <b>{{ this.last4Digits }}</b>
              </p>
              <v-text-field
                v-model="code"
                label="Code"
                type="text"
                :rules="codeRules"
                required
              ></v-text-field>
            </div>

            <v-alert v-if="!codeCorrect" type="error">
              Code does not match
            </v-alert>

            <v-btn class="btn-submit" color="#2bb9aa" @click="reset"
              >RESET PASSWORD</v-btn
            >
            <div class="mt-5"></div>
          </v-form>
        </v-card-text>
      </v-card>

      <div class="lang">
        <lang-select></lang-select>
        <div class="label-sms-send-again">
          SMS didn't come? <a>Send again</a>
        </div>
      </div>
    </div>
    <div class="grey-background"></div>
  </div>
</template>

<script>
export default {
  created() {
    if (
      !this.$store.state.auth.reset_code ||
      !this.$store.state.auth.phone_number
    ) {
      this.$router.push({ path: "/password-reset-request" });
    }

    let phone = this.$store.state.auth.phone_number;
    this.last4Digits = phone ? phone.substr(phone.length - 4) : "";
  },

  data: () => ({
    codeRules: [
      value => !!value || "Required",
      value => (value || "").length == 6 || "Require 6 characters"
    ],

    valid: false,
    loading: false,

    code: "",
    codeCorrect: true
  }),

  methods: {
    reset() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.$store.state.auth.reset_code != this.code.toUpperCase()) {
        this.codeCorrect = false;
        return;
      }

      this.loading = true;
      this.$store
        .dispatch("reset_verify", {})
        .then(() => {
          this.loading = false;
          this.$router.push({ path: "/password-reset-new" });
        })
        .catch(() => {
          this.loading = false;
          this.codeCorrect = false;
        });
    }
  }
};
</script>
